<template>
  <div class="std-fixed">
    <div class="icon icon3" @click="searchProduct" v-if="supportSearch"><i class="el-icon-search"></i></div>

    <div class="icon icon3">咨<img src="../../../assets/img/std_ask.png"></div>
    <div class="icon icon1" ><img src="../../../assets/img/std_qrcode.png"></div>
    <el-dropdown  v-if="isLogin" trigger="hover" @command="onCommand" placement="left">
      <span class="el-dropdown-link">
        <div class="icon icon2"></div>
      </span>
      <el-dropdown-menu slot="dropdown" style="margin-right: 0;">
        <el-dropdown-item command="logout">退出帐号</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

  </div>
</template>

<script>
import userApi from "@/assets/js/userApi";
export default {
  name: "stdFixed",
  props: {
    /**
     * 是否开启搜索
     */
    supportSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      roleAbbr: '',
      messagecolor:"#568cd5",
      showZkView: false,
      isLogin : false
    }
  },
  watch : {
    "$store.getters.isLogin" : {
      handler( value ){
        this.isLogin  = value;
      }
    }
  },
  methods: {
    iconColor(){
       this.messagecolor="#fff"
    },
    onCommand(command) {
      console.log(command);
      switch (command) {
        //切换专业版，去辅助决策平台
        case 'toPlus':this.toPLus(); break;
        case 'toVista':
          window.location = '/vista.html'; break;
        case 'changeRole':
          this.$emit('changeRole'); break;
        case 'toCmdpStd':
          this.toCmdpStd(); break;
        case 'logout':
          this.logout(); break;
      }
    },
    logout() {
      this.$store.dispatch( "setLogin", false );
      userApi.doLogout(_r => {
        sessionStorage.clear();
        localStorage.clear();
        window.location = "/index";
      });
      this.isLogin  = false;
    },
    changeRoleAbbr(str) {
      this.roleAbbr = str
    },
    openTaskCenter(){
      this.$EventBus.$emit('opendialogTaskCenter')
     // this.$emit('openTaskCenter')
    },
    // 去决策辅助平台
    toPLus(){
      window.location.href=`${config.cmdpWebUrl}/plus/apps/bigScreen/decsisionSupportVega`
    },
    //打开数字智库标准版页面
    toCmdpStd(){
      // window.open(`${config.cmdpWebUrl}/std/index`,'_blank');
      window.location.href = `${config.cmdpWebUrl}/std/index`;
    },
    searchProduct() {
      this.$emit('openSearch');
    }
  },
  created(){
    //只有数字化智库页面才显示
    this.showZkView = this.$route.path.indexOf("/zkindex") > -1 ?  true : false;
    this.isLogin  = localStorage.getItem("USER_ISLOGIN");
    // console.log(this.$route.path);
  }
}
</script>
<style lang="less" scoped>
.myicon:hover{
  color:#ffffff;
}

.std-fixed {
  position: fixed;
  right: 0;
  bottom:35%;
  zoom: 1;
  z-index:100;
  div.icon {
    width: 78px;
    height: 78px;
    cursor: pointer;
    position: relative;
  }

  .icon1 {
    background: transparent url("../../../assets/img/std_fixed_icon1.png") center center no-repeat;
    background-size: cover;
    > img {
      position: absolute;
      display: none;
    }
    &:hover {
      background: transparent url("../../../assets/img/std_fixed_icon1_hover.png") center center no-repeat;
      > img {
        display: block;
        left: -165px;
        top: -60px;
        width:auto;
        height:auto;
      }
    }
  }
  .icon2 {
    background: transparent url("../../../assets/img/std_fixed_icon2.png") center center no-repeat;
    background-size: cover;
    &:hover {
      background: transparent url("../../../assets/img/std_fixed_icon2_hover.png") center center no-repeat;
    }
  }
  .icon3 {
    background: transparent url("../../../assets/img/std_fixed_icon3.png") center center no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding-bottom: 5px;
    color:#409EFF;
    font-size: 22px;
    > img {
      position: absolute;
      display: none;
    }
    &:hover {
      background: transparent url("../../../assets/img/std_fixed_icon3_hover.png") center center no-repeat;
      color:#ffffff;
      > img {
        display: block;
        left: -165px;
        top: -60px;
        width:auto;
        height:auto;
      }
      >button{
        color:#ffffff !important;
      }
    }
  }
}

</style>
